import { NavBar } from "../../Components/NavBar/NavBar"
import { CreateMemorieForm } from "../../Components/CreateMemorieForm/CreateMemorieForm"

export const CreateMemories = () => {
  return (
    <div>
      <NavBar />
      <>
        <CreateMemorieForm />
      </>
    </div>
  )
}
